(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/compose-finalized-result-message.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/compose-finalized-result-message.js');
"use strict";


const _svs$utils$format = svs.utils.format,
  formatCurrencyAsString = _svs$utils$format.Currency,
  formatCurrencyAsNumber = _svs$utils$format.CurrencyFromJupiterString;
const composeGroupWinMessage = _ref => {
  let groupData = _ref.groupData,
    productName = _ref.productName;
  const groupWinAmount = groupData.groupWinAmount,
    groupAddonWinamount = groupData.groupAddonWinamount,
    playerWinAmount = groupData.playerWinAmount,
    playerAddonWinamount = groupData.playerAddonWinamount;
  if (groupWinAmount > 0 && groupAddonWinamount > 0) {
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(groupWinAmount), " kr")), " p\xE5 ".concat(productName, " och "), React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(groupAddonWinamount), " kr")), " p\xE5 Sportkryss! ", React.createElement("br", null), 'Din vinst är ', React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(playerWinAmount), " kr")), " p\xE5 ".concat(productName, " och "), React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(playerAddonWinamount), " kr")), " p\xE5 Sportkryss! ", ' Vinsten har satts in på ditt spelkonto.');
  }
  if (groupAddonWinamount > 0) {
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(groupAddonWinamount), " kr")), " p\xE5 Sportkryss! Din vinst \xE4r ", React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(playerAddonWinamount), " kr.")), ' Vinsten har satts in på ditt spelkonto.');
  }
  return React.createElement(React.Fragment, null, React.createElement("span", {
    className: "no-wrap"
  }, "".concat(formatCurrencyAsString(groupWinAmount), " kr")), " p\xE5 ".concat(productName, "! Din vinst \xE4r "), React.createElement("span", {
    className: "no-wrap"
  }, "".concat(formatCurrencyAsString(playerWinAmount), " kr.")), ' Vinsten har satts in på ditt spelkonto.');
};
const composeFinalizedResultMessage = _ref2 => {
  let correctCount = _ref2.correctCount,
    groupData = _ref2.groupData,
    productName = _ref2.productName,
    winAmount = _ref2.winAmount,
    addonWinAmount = _ref2.addonWinAmount,
    productWinAmount = _ref2.productWinAmount;
  const parsedWinAmount = winAmount ? formatCurrencyAsNumber(winAmount) : 0;
  if (parsedWinAmount > 0 && groupData !== null && groupData !== void 0 && groupData.groupName) {
    const groupName = groupData.groupName;
    if (correctCount) {
      return React.createElement(React.Fragment, null, "".concat(groupName, " fick ").concat(correctCount, " r\xE4tt p\xE5 ").concat(productName, " och har vunnit "), composeGroupWinMessage({
        groupData,
        productName
      }));
    }
    return React.createElement(React.Fragment, null, "".concat(groupName, " har vunnit "), composeGroupWinMessage({
      groupData,
      productName
    }));
  }
  if (addonWinAmount > 0 && productWinAmount > 0) {
    return React.createElement(React.Fragment, null, 'Du har vunnit ', React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(productWinAmount), " kr p\xE5 ").concat(productName, " och ").concat(formatCurrencyAsString(addonWinAmount), " kr p\xE5 Sportkryss!  ")), ' Vinsten har satts in på ditt spelkonto.');
  }
  if (addonWinAmount > 0) {
    return React.createElement(React.Fragment, null, 'Du har vunnit ', React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(addonWinAmount), " kr p\xE5 Sportkryss!  ")), ' Vinsten har satts in på ditt spelkonto.');
  }
  if (parsedWinAmount > 0) {
    if (correctCount) {
      return React.createElement(React.Fragment, null, "Du fick ".concat(correctCount, " r\xE4tt p\xE5 ").concat(productName, " och har vunnit "), React.createElement("span", {
        className: "no-wrap"
      }, "".concat(formatCurrencyAsString(winAmount), " kr. ")), "Vinsten har satts in p\xE5 ditt spelkonto.");
    }
    return React.createElement(React.Fragment, null, 'Du har vunnit ', React.createElement("span", {
      className: "no-wrap"
    }, "".concat(formatCurrencyAsString(winAmount), " kr")), " p\xE5 ".concat(productName, "! Vinsten har satts in p\xE5 ditt spelkonto."));
  }
  if (groupData !== null && groupData !== void 0 && groupData.groupName) {
    return "Tyv\xE4rr ingen vinst p\xE5 ".concat(productName, " f\xF6r ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.groupName, " denna g\xE5ng.");
  }
  return "Tyv\xE4rr ingen vinst p\xE5 ".concat(productName, " denna g\xE5ng.");
};
setGlobal('svs.components.poolBetting.utils', {
  composeFinalizedResultMessage
});

 })(window);